module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"inbox":"Inbox","sent":"Sent","sendMessage":"Send message"},"et":{"inbox":"Inbox","sent":"Sent","sendMessage":"Send message"},"ru":{"inbox":"Inbox","sent":"Sent","sendMessage":"Send message"}}')
  delete Component.options._Ctor
}
